<div class="app-project-menu">
  <button class="topbar-icon-btn" (click)="openPanel()" title="Aplicações" #shortcutsOrigin>
    <span class="material-icons">grid_view</span>
  </button>

  <ng-template #shortcutsPanel>
    <div class="panel-container">
      <div class="apps-grid">
        <ng-container *ngFor="let shortcut of shortcuts; trackBy: trackByFn">
          <a class="f-card" (click)="goToApplication(shortcut)" [title]="'Acessar sistema ' + shortcut.label">
            <div class="card-icon">
              <span class="material-icons icon">{{shortcut.icon}}</span>
            </div>
            <div class="card-title"><span>{{shortcut.label}}</span></div>
            <div class="card-footer"><span>Acessar Sistema</span></div>
          </a>
        </ng-container>
      </div>

      <ng-container *ngIf="!shortcuts || !shortcuts.length">
        <div class="apps-empty">
          <span class="material-icons-outlined">bookmark</span>
          <div class="apps-empty-title">Sem acessos disponíveis</div>
          <div class="apps-empty-text">Quando você tiver algum acesso, eles aparecerão aqui.</div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>
